module.exports = __webpack_public_path__ + "img/miso-burgers.b61c9b40.jpg";